// App-wide actions that open modals owned by a feature (features never import each other):
// the shell defines the contract, src/app/GlobalActions.tsx implements it with the features' modals.
import { createContext, useContext } from 'react';

export type GlobalActions = {
  /** «Создать сайт»: the create-site modal, with an organization preselected when given. */
  openCreateSite: (organizationId?: string) => void;
  /** «Новая организация»: the new-organization modal over the current page (the sidebar CTA, the list). */
  openNewOrganization: () => void;
};

export const GlobalActionsContext = createContext<GlobalActions | null>(null);

export function useGlobalActions(): GlobalActions {
  const ctx = useContext(GlobalActionsContext);
  if (!ctx) throw new Error('useGlobalActions must be used inside <GlobalActionsProvider>');
  return ctx;
}
